<template>
  <header
    class="a-service-header"
    :class="classSelectLogo"
  >
    <div class="header-inner">
      <h1 class="sp_a-service sp_header-logo">
        <a
          v-if="showAmwayLogo"
          :href="amwayAddress"
          class="link-home"
        >Amway
        </a>
        <router-link
          v-else
          to="/"
          class="link-home"
        >my pack</router-link>
        <!-- <a
          :href="$router.push('/')"
          class="link-home"
        ><span class="a11y">Amway</span></a> -->
      </h1>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    mainLogo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      amwayAddress: '',
    };
  },
  computed: {
    showAmwayLogo() {
      if (this.mainLogo) {
        return true;
      }
      return false;
    },
    classSelectLogo() {
      if (this.mainLogo) {
        return '';
      }
      return 'type_mypack';
    },
  },
  created() {
    this.amwayAddress = `https://${process.env.SSO_HOST}/main`;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AppHeader.vue